import React from "react";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import { useState, useEffect } from "react";
import { triggerNotification } from "../../component/message/Msg";
import { useNavigate, useParams } from "react-router-dom";
import config from "../../config";
import makeAnimated from "react-select/animated";
import Spinner from "../../component/loadingbar/Spinner";
import MediaPopup from "../../component/mediapopup/MediaPopup";
import Select from "react-select";

const AddPackage = () => {
  const { id } = useParams();
  const token = config.token;
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();

  //--------------------------------- manage state ---------------------------------
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  const [imageLinkValue, setImageLinkValue] = useState("");
  const [iconLinkValue, setIconLinkValue] = useState("");
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [formData, setFormData] = useState({
    pkg_name: "",
    pkg_priority: "",
    pkg_type: "",
    pkg_catagory_name: "",
    demo_content: "",
  });
  const [plans, setPlans] = useState([
    {
      price: "",
      duration: "",
      durationUnit: "days",
      promotional_price: "",
    },
  ]);

  const handlePlanChange = (e, i) => {
    setPlans((prevPlans) => {
      const newPlans = [...prevPlans];
      newPlans[i] = {
        ...newPlans[i],
        [e.target.name]: e.target.value,
      };
      return newPlans;
    });
  };
  const handleChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };
  const handleCourseChange = (selectedOptions) => {
    setSelectedCourses(selectedOptions);
  };

  // ----------------------------------------------- Read / Select / Get courses ---------------------------------------------R
  useEffect(() => {
    fetch(`${config.host_url}course`, {
      method: "GET",
      headers: {
        token: token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          const courseOptions = data.data.map((course) => ({
            value: course.course_name,
            label: course.course_name,
            id: course.course_id,
          }));
          setCourses(courseOptions);
        } else if (data.status === 401) {
          // Invalid token
          console.error("Invalid token");
        } else {
          // Handle other errors
          console.error("Internal server error");
        }
      })
      .catch((error) => {
        console.error("Error fetching course:", error);
      });
  }, [token]);

  // ---------------------------------- Read / Select / Get package data for edit -----------------------------------R
  const updateFieldValueSet = async () => {
    setLoading(true);
    try {
      await fetch(
        `${config.host_url}packages/${decodeURIComponent(atob(id))}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            console.log(data.data);
            // Successful response, update the media list
            const selectedCoursesOptions = data.data.courses.map((course) => ({
              value: course.course_name,
              label: course.course_name,
              id: course.courseid,
            }));
            setSelectedCourses(selectedCoursesOptions);
            setFormData({
              pkg_name: data.data?.pkg_name,
              pkg_priority: data.data?.pkg_priority,
              pkg_type: data.data?.pkg_type,
              pkg_catagory_name: data.data?.pkg_catagory_name,
              demo_content: data.data?.demo_content,
            });
            setImageLinkValue(data.data.pkg_display_image);
            setIconLinkValue(data.data.pkg_display_icon);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching courses.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id !== undefined) {
      updateFieldValueSet();
    }
  }, [id]);

  //--------------------------------------- functionality for plans  ---------------------------------------
  const handleAddPlanBtn = () => {
    setPlans((oldPlans) => {
      return [
        ...oldPlans,
        {
          price: "",
          duration: "",
          durationUnit: "days",
          promotional_price: "",
        },
      ];
    });
  };
  const handleRemovePlanBtn = (index) => {
    const planlist = [...plans];
    planlist.splice(index, 1);
    setPlans(planlist);
  };

  //---------------------------------------------- create / add / update package ------------------------------------C--U
  const handleSubmitPackage = async () => {
    if (
      !formData.pkg_name.trim() ||
      !formData.pkg_priority.trim() ||
      !formData.pkg_type.trim() ||
      !formData.pkg_catagory_name.trim() ||
      !imageLinkValue.trim() ||
      !iconLinkValue.trim() ||
      !formData.demo_content.trim() ||
      !selectedCourses.length > 0 ||
      (!id &&
        !plans.every(
          (plan) =>
            plan.duration !== "" &&
            plan.durationUnit !== "" &&
            plan.price !== ""
        ))
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return;
    }
    try {
      fetch(
        `${config.host_url}packages/${id ? decodeURIComponent(atob(id)) : ""}`,
        {
          method: `${id ? "PUT" : "POST"}`,
          headers: {
            "Content-Type": "application/json",
            token: token,
          },
          body: JSON.stringify({
            pkg_name: formData.pkg_name,
            pkg_priority: formData.pkg_priority,
            pkg_type: formData.pkg_type,
            pkg_catagory_name: formData.pkg_catagory_name,
            pkg_display_image: imageLinkValue,
            pkg_display_icon: iconLinkValue,
            demo_content: formData.demo_content,
            plan_for: plans?.map((plan) => plan.duration),
            plan_unit: plans?.map((plan) => plan.durationUnit),
            plan_price: plans?.map((plan) => plan.price),
            promotional_price: plans?.map((plan) => plan.promotional_price),
            courseid: selectedCourses?.map((course) => course.id),
          }),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification(
              "success",
              `Package ${id ? "updated" : "created"} successfully.`
            );
            setFormData({
              pkg_name: "",
              pkg_priority: "",
              pkg_type: "",
              pkg_catagory_name: "",
              demo_content: "",
            });
            setPlans({
              price: "",
              duration: "",
              durationUnit: "days",
              promotional_price: "",
            });
            setIconLinkValue("");
            setImageLinkValue("");
            setSelectedCourses("");
            navigate("/viewpackages");
          } else if (data.status === 400) {
            // Handle validation errors
            triggerNotification("error", "Validation Error.");
          } else if (data.status === 401) {
            // Handle unauthorized (invalid token)
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other server errors
            triggerNotification("error", "Internal server error.");
          }
        })
        .catch((error) => {
          // Handle fetch error here
          console.error("Fetch error:", error);
        });
    } catch (error) {
      console.error("Error creating course:", error);
      triggerNotification(
        "error",
        "An error occurred while creating the course."
      );
    }
  };

  //
  const clearForm = () => {
    setFormData({
      pkg_name: "",
      pkg_priority: "",
      pkg_type: "",
      pkg_catagory_name: "",
      demo_content: "",
    });
    setPlans([
      {
        price: "",
        duration: "",
        durationUnit: "days",
        promotional_price: "",
      },
    ]);
    setIconLinkValue("");
    setImageLinkValue("");
    setSelectedCourses("");

    if (id) {
      navigate("/viewpackages");
    }
  };
  return (
    <>
      <Breadcrumb txt="Manage Package" subpath={["Add Package"]} />
      {/* form view */}
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center ">
            <h5 className="mb-0">Add Package</h5>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="card-body">
              <form>
                {/* Package Name | Package Priority */}
                <div className="row">
                  {/* Package Name */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="pkg_name"
                        id="pkg_name"
                        placeholder="Package Name"
                        value={formData.pkg_name}
                        onChange={handleChange}
                      />
                      <label htmlFor="pkg_name"> Package Name</label>
                    </div>
                  </div>
                  {/* Package Priority */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="pkg_priority"
                        id="pkg_priority"
                        placeholder="Package Priority"
                        value={formData.pkg_priority}
                        onChange={handleChange}
                      />
                      <label htmlFor="pkg_priority"> Package Priority</label>
                    </div>
                  </div>
                </div>

                {/* Package Type | Package Category Name  */}
                <div className="row">
                  {/* Package Type */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="pkg_type"
                        id="pkg_type"
                        placeholder="Package Type"
                        value={formData.pkg_type}
                        onChange={handleChange}
                      />
                      <label htmlFor="pkg_type"> Package Type</label>
                    </div>
                  </div>
                  {/* Package Category Name */}
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="pkg_catagory_name"
                        id="pkg_catagory_name"
                        placeholder="Package Category Name"
                        value={formData.pkg_catagory_name}
                        onChange={handleChange}
                      />
                      <label htmlFor="pkg_catagory_name">
                        {" "}
                        Package Category Name
                      </label>
                    </div>
                  </div>
                </div>

                {/* Demo Content */}
                <div className="form-floating form-floating-outline mb-4">
                  <textarea
                    className="form-control"
                    name="demo_content"
                    id="demo_content"
                    placeholder="Demo Content"
                    value={formData.demo_content}
                    onChange={handleChange}
                    style={{ height: "100px" }}
                  ></textarea>
                  <label htmlFor="demo_content"> Demo Content</label>
                </div>

                {/* courseid */}
                <div className="form-floating form-floating-outline mb-4 ">
                  <Select
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    isMulti
                    options={courses}
                    value={selectedCourses}
                    placeholder="Select courses"
                    onChange={handleCourseChange}
                  />
                </div>

                {/* Package Display Image */}
                <MediaPopup
                  ttl="Image"
                  linkValue={imageLinkValue}
                  setLinkValue={setImageLinkValue}
                  mediaType="images"
                />

                {/* Package Display Icon */}
                <MediaPopup
                  ttl="Icon"
                  linkValue={iconLinkValue}
                  setLinkValue={setIconLinkValue}
                  mediaType="images"
                />

                {/* Plans */}
                {!id && (
                  <>
                    <div>
                      <label className="form-check-label ml-1 mb-3">
                        Plans
                      </label>
                      {plans?.map((plan, i) => (
                        <div key={i} className="row">
                          {/*  Duration */}
                          <div className="col-md-2">
                            <div className="form-floating form-floating-outline mb-4  ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Duration"
                                value={plan.duration}
                                name="duration"
                                onChange={(e) => handlePlanChange(e, i)}
                              />
                              <label htmlFor="basic-default-phone">
                                Duration
                              </label>
                            </div>
                          </div>
                          {/* Duration unit */}
                          <div className="col-sm-2">
                            <div className="form-floating form-floating-outline mb-4">
                              <select
                                className="form-select"
                                id="exampleFormControlSelect1"
                                aria-label="Default select example"
                                value={plan.durationUnit}
                                name="durationUnit"
                                onChange={(e) => handlePlanChange(e, i)}
                              >
                                <option value="days">Days</option>
                                <option value="weeks">Weeks</option>
                                <option value="months">Months</option>
                              </select>
                              <label htmlFor="exampleFormControlSelect1">
                                Duration Unit
                              </label>
                            </div>
                          </div>
                          {/* Price */}
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4 ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Price"
                                value={plan.price}
                                name="price"
                                onChange={(e) => handlePlanChange(e, i)}
                              />
                              <label htmlFor="basic-default-phone">Price</label>
                            </div>
                          </div>
                          {/* promotional_price */}
                          <div className="col-md-3">
                            <div className="form-floating form-floating-outline mb-4 ">
                              <input
                                type="number"
                                min="1"
                                id="basic-default-phone"
                                className="form-control phone-mask"
                                placeholder="Promotional Price"
                                value={plan.promotional_price}
                                name="promotional_price"
                                onChange={(e) => handlePlanChange(e, i)}
                              />
                              <label htmlFor="basic-default-phone">
                                Promotional Price
                              </label>
                            </div>
                          </div>
                          {/* cancel plan */}
                          {i > 0 && (
                            <div
                              className="text-red-600 col-sm-2 select-none"
                              onClick={() => handleRemovePlanBtn(i)}
                            >
                              <span className="mdi mdi-close pr-2"></span>
                              Remove Plan
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    <button
                      type="button"
                      className="btn btn-outline-secondary mb-4 "
                      onClick={() => handleAddPlanBtn()}
                    >
                      Add More Plan
                    </button>
                    <hr className="mb-4 mt-2" />
                  </>
                )}

                {/* submit */}
                <div className="mt-3 justify-content-end">
                  <div className="col-sm-10">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmitPackage}
                    >
                      {id ? "update" : "Submit"}
                    </button>
                    {/* clear | calcel */}
                    <button
                      type="button"
                      className="btn ml-2 btn-secondary"
                      onClick={clearForm}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AddPackage;
